import {default as nodePath} from "path";
import {set} from "lodash/object";
import {mapValuesAsync} from "../helpers";
import {Kind} from "graphql";
import handleInput from "./helpers/handleInput";

export function isFileInput(o) {
    // duck typing
    return o?.path && o?.filename && o?.mimetype && o?.encoding && o?.size;
}

export async function s3request(req) {
    return new Promise((resolve, reject) => {
        req.on('success', (resp) => {
            resolve(resp.data);
        });
        req.on('error', (error) => {
            reject(error);
        });
        req.send();
    });
}

export default function moveFiles(types, fields, destination: ? string | Function) {
    fields = Array.isArray(fields) ? fields : [fields];
    types = Array.isArray(types) ? types : [types];

    const handler = async (argType, argValue, argName, path, c) => {
        for (let field of fields) {
            if (!argValue[field]) continue;

            const moveFile = async file => {
                const newPath = destination instanceof Function
                    ? destination(argType, argValue, argName, path)
                    : nodePath.join(destination, nodePath.parse(file.path).base);

                const copyParams = {Bucket: c.s3Bucket, CopySource: `/${c.s3Bucket}/` + file.path, Key: newPath};
                console.log('Moving file');
                console.log(copyParams);
                console.log('s3request', await s3request(c.storage.copyObject(copyParams)));

                return {...file, path: newPath}
            };

            let moved = await mapValuesAsync(argValue[field], async file => {
                if (!isFileInput(file)) {
                    return file;
                }
                return file instanceof Array
                    ? await Promise.all(file.map(f => moveFile(f)))
                    : await moveFile(file);
            });
            argValue = set({...argValue}, field, moved);
        }
        return argValue;
    }

    return ({typeDefs, resolvers}) => {
        for (let type of types) {
            typeDefs = handleInput(typeDefs, type, handler)
        }
        return {typeDefs, resolvers};
    }
}
